import { PlatformEvent } from "@freeplay/shared-code";
import React from "react";
import { Text, View } from "react-native";
import { useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { EStyleSheet } from "react-native-extended-stylesheet-typescript";
import { GlobalStyles } from "../style/Style";

export interface OutcomeInfoDisplayProps {
    outcome: PlatformEvent;
    isUser?: boolean;
}

export enum PlatformEventStatusEnum { // ! TEMP enum to be moved
    NOT_STARTED = "not_started", // initial
    LIVE = "live", // when i'm seeing it in open.json
    FINISHED = "finished", // it WAS live, no longer in open.json so event is done - need to score outcomes
    EXPIRED = "expired", // It never left not started and it's expired and was never found in open
    SCORED = "scored", // ran through offers + outcomes, marking victory!
}

export const OutcomeInfoDisplay: React.FC<OutcomeInfoDisplayProps> = ({ outcome, isUser }) => {
    const styles = useDynamicStyles(createOutcomeStyles);
    const getScoreDisplay = () => {
        const scored = outcome.platformEventStatus === PlatformEventStatusEnum.SCORED;

        if (!scored) {
            return <></>;
        }

        const homeWin = outcome.homeScore > outcome.awayScore;
        const homeStyle = homeWin ? styles.lose : styles.win;
        const awayStyle = homeWin ? styles.win : styles.lose;

        return (
            <View style={styles.scoreContainer}>
                <Text style={[styles.score, homeStyle]}>{outcome.awayScore || 0}</Text>
                <Text style={styles.dash}> - </Text>
                <Text style={[styles.score, awayStyle]}>{outcome.homeScore || 0}</Text>
            </View>
        );
    };

    return <>{getScoreDisplay()}</>;
};

// Needs a fix in EStyleSheet, need to export return type of create.
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createOutcomeStyles = () => {
    return EStyleSheet.create({
        scoreContainer: {
            justifyContent: "center",
            flexDirection: "row",
            marginBottom: 10,
        },
        score: {
            fontSize: 24,
            lineHeight: 24,
            fontWeight: "700",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
        },
        dash: {
            fontSize: 24,
            lineHeight: 24,
            fontWeight: "700",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
        },
        lose: {
            color: () => EStyleSheet.value(GlobalStyles.LOSS_TEXT),
        },
        win: {
            color: () => EStyleSheet.value(GlobalStyles.WIN_TEXT),
        },
    });
};
